export interface AuthState {
  username: string;
  isLogged?: boolean;
  accessToken: string;
  tokenExpiresDate: Date | null;
}

export const state = (): AuthState => ({
  username: '',
  accessToken: '',
  isLogged: false,
  tokenExpiresDate: null,
});
